interface SetCookieType {
	name: string
	value: string | number | undefined
	days: number
	mins: number
}

export const setCookie = ({ name, value, days, mins }: SetCookieType) => {
	const date = new Date()
	date.setTime(date.getTime() + (days ? days * 24 * 60 : 1 + mins) * 60 * 1000)
	const expires = `expires=${date.toUTCString()}`
	let domain = 'domain='
	if (typeof window !== 'undefined') {
		if (window.location.hostname.indexOf('lenskart.com') > -1) {
			domain += '.lenskart.com'
		} else {
			domain += window.location.hostname
		}
		document.cookie = `${name}=${value};${expires};${domain};path=/`
	}
}

export const deleteCookie = (cname: string) => {
	let domain = 'domain='
	if (window.location.hostname.indexOf('lenskart.com') > -1) {
		domain += '.lenskart.com'
	} else {
		domain += window.location.hostname
	}
	document.cookie = `${cname}=;expires=${new Date(
		new Date().getTime()
	).toUTCString()};${domain};path=/`
}

export const getCookie = (cname: string) => {
	const name = `${cname}=`
	if (typeof window !== 'undefined') {
		const decodedCookie = decodeURIComponent(document.cookie)
		const cookieSplit = decodedCookie.split(';')
		for (let index = 0; index < cookieSplit.length; index += 1) {
			let cookie = cookieSplit[index]
			while (cookie.charAt(0) === ' ') {
				cookie = cookie.substring(1)
			}
			if (cookie.indexOf(name) === 0) {
				return cookie.substring(name.length, cookie.length)
			}
		}
	}
	return ''
}
